module.exports = "/_next/static/images/trustpilot-logo-ef8c8ff8da1cf9e9135a4ee82e88b51d.svg";